import { Observable } from 'rxjs';
import { Auth } from 'src/app/domain/models/auth.model';

export abstract class AuthPort {
  abstract fetchUserAttributes(): Observable<Auth>;
  abstract fetchAuthSession(): Observable<string>;
  abstract signOut(): Observable<void>;
}
